export default "__VITE_ASSET__9b2d98c7__"